// extracted by mini-css-extract-plugin
module.exports = {"interiorSeparationImgWrapper":"SeparatorsSelector_interiorSeparationImgWrapper__mhaCA"};